import { AfterViewInit, Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { SplitViewObserverService } from '../split-view/split-view-observer.service';
import { delay, map } from 'rxjs/operators';
import { merge, Observable, Subject } from 'rxjs';
import { TruncationMode } from '../../enums/truncation-mode';
import { SettingsService } from '../../settings/settings.service';

@Component({
    selector: 'ldw-truncated-text',
    templateUrl: './truncated-text.component.html',
    styleUrls: ['./truncated-text.component.css'],
    standalone: false
})
export class TruncatedTextComponent implements AfterViewInit {
  private splitviewObserver = inject(SplitViewObserverService);
  private settingsService = inject(SettingsService);

  @Input() set text(value) {
    this._text = value;
    this.splitviewObserver.notifyMoved({ gutterNum: 0 });
  }
  get text() {
    return this._text;
  }
  private _text = '';
  truncationMode = TruncationMode; // workaround to make enum available in template

  @ViewChild('ellipsisMiddle') ellipsisMiddle: ElementRef<HTMLElement> | undefined;
  @ViewChild('ellipsisStart') ellipsisStart: ElementRef<HTMLElement> | undefined;

  needsTruncation: Observable<boolean>;
  loaded$ = new Subject<{ isMoving: boolean }>();
  truncMode(): TruncationMode {
    return this.settingsService.settings.viewMode.textTruncation;
  }

  ngAfterViewInit() {
    this.loaded$.next({ isMoving: false });
  }

  constructor() {
    const splitviewObserver = this.splitviewObserver;

    this.needsTruncation = merge(splitviewObserver.observe(), this.loaded$.pipe(delay(100))).pipe(
      map((event) => {
        return event.isMoving
          ? false
          : (this.ellipsisMiddle?.nativeElement?.clientWidth || 0) <
              (this.ellipsisStart?.nativeElement?.scrollWidth || 0);
      })
    );
    /* text truncation mode from settings */
  }
}
